"use strict";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var styleOverrides = {
    root: function(param) {
        var variant = param.ownerState.variant, theme = param.theme;
        return _object_spread({
            cursor: 'pointer',
            '&:hover': {
                color: theme.palette.text.hover
            }
        }, variant === 'button' && {
            textUnderlineOffset: '.25em',
            textDecorationThickness: '2px'
        });
    },
    underlineAlways: {
        textDecorationColor: 'currentcolor'
    }
};
var defaultProps = {
    underline: 'always',
    variant: 'body1',
    color: 'textPrimary'
};
var _default = exports.default = {
    styleOverrides: styleOverrides,
    defaultProps: defaultProps
}; //# sourceMappingURL=MuiLink.js.map
